import React from 'react';
import FormGroupPart from './FormGroupPart';
import messages from '../registrationMessages';
import { FormattedNumber } from 'react-intl';
import classNames from 'classnames';

const AbsenceBalanceFormGroup = ({
  absenceBalance,
  durationType,
  intl,
  durationDays,
  duration,
  showValidation,
}) => {
  if (!absenceBalance) return null;

  const { balance, hoursInDay, balanceDays, maxDays, maxMinutes } = absenceBalance;
  ///

  const balanceAfter =
    durationType === 0 ? balance - (duration ?? 0) / 60 : balanceDays - (durationDays ?? 0);

  return (
    <div className="form-group">
      <FormGroupPart label={messages.AbsenceBalance}>
        {durationType === 0 ? (
          <p className="form-control-static">
            <FormattedNumber value={balance ?? 0} maximumFractionDigits={2} />
            &nbsp;
            <span>{intl.formatMessage(messages.Hours)}</span>
          </p>
        ) : (
          <p className="form-control-static">
            <FormattedNumber value={balanceDays ?? 0} maximumFractionDigits={2} />
            &nbsp;
            <span>{intl.formatMessage(messages.Days)}</span>
          </p>
        )}
      </FormGroupPart>
      <FormGroupPart label={messages.BalanceAfter} invalid={showValidation && balanceAfter < 0}>
        <p className={classNames('form-control-static', { errorMsg: balanceAfter < 0 })}>
          <FormattedNumber value={balanceAfter ?? 0} maximumFractionDigits={2} />
          &nbsp;
          <span>{intl.formatMessage(durationType === 0 ? messages.Hours : messages.Days)}</span>
        </p>
      </FormGroupPart>
    </div>
  );
};
export default AbsenceBalanceFormGroup;
